/* Button that opens a popup kept in a sibling <template> — see
   snippets/intake-notify-cta.liquid and snippets/ask-question-popup.liquid. */
import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

class PopupCta extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector(":scope > button");
    this.template = this.querySelector(":scope > template");
    if (!this.button || !this.template) return;

    this.onClick = this.onClick.bind(this);
    this.button.addEventListener("click", this.onClick);

    // A native form post reloads the page at #<form id>, so reopen to show its result.
    const openHash = this.dataset.openOnHash;
    if (openHash && window.location.hash === `#${openHash}`) {
      this.onClick();
      this.clearPostedUrl();
    }
  }

  // Without this a reload repeats the posted URL and reopens the result every time.
  clearPostedUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete("contact_posted");
    url.hash = "";
    history.replaceState(history.state, "", url);
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener("click", this.onClick);
  }

  onClick() {
    // A popup still fading out from the last close has a removal pending, so it
    // is dropped and a fresh one cloned rather than reopened.
    document.getElementById(this.dataset.popupId)?.remove();
    const popup = this.template.content.firstElementChild.cloneNode(true);
    NextSkyTheme.getBody().appendChild(popup);
    NextSkyTheme.global.rootToFocus = this.button;
    // Same delay as AskQuestion in theme.js, so the invisible state paints first.
    setTimeout(() => eventModal(popup, "open", true), 100);
  }
}

if (!customElements.get("popup-cta")) {
  customElements.define("popup-cta", PopupCta);
}
